export enum AuthType {
  Snap = 'snapretail',
  Google = 'google',
  Facebook = 'facebook',
}

export enum ErrorCode {
  Unknown = 0,
  AccountDoesNotExist = 6,
  RequirePreviousAuth = 7,
}

export const headerNames = {
  AUTH_TYPE: 'X-SnapRetail-AuthType',
  PENDING_AUTH: 'X-SnapRetail-Pending-Auth',
  REDIRECT_URL: 'X-Redirect-Url',
};

export const queryStrings = {
  RETURN_URL: 'ReturnUrl',
  REFERRER: 'referrer',
  IGNORE_WORKFLOW: 'ignoreWorkflow',
};

const configElementDataSet = (document.querySelector('#sign-in') as HTMLElement).dataset;

export const googleConfig = {
  CLIENT_ID: configElementDataSet.googleOAuthClientId,
  SCOPE: 'profile email openid',
};

export const facebookConfig = {
  APP_ID: configElementDataSet.facebookAppId,
  API_VERSION: 'v2.10',
  SCOPE: 'public_profile,email',
};

const snap = (window as any).snap;

export const urls = {
  ERROR_LOGGING: snap.LOG_ERROR_URL,
  SNAP_SIGNIN: `${snap.RETAILER_API_URL}/accounts/SignIn`,
  SNAP_SIGNUP: `${snap.RETAILER_API_URL}/accounts`,
};

export const selectors = {
  MASTER_CONTROL: '.sign-in__master-control',
  FORM: '.sign-in__form',
  FORM_HELPTEXT: '.sign-in__form__helptext',
  FORM_SUBMIT: '.sign-in__submit',
  CONTROL: '.form-control',
  CONTROL_INPUT: '.form-control__input',
  CONTROL_HELPTEXT: '.form-control__helptext',
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/constants.ts